import styled from "styled-components";

export const EditTournamentReservationWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const EditTournamentReservationTop = styled.div`
  display: flex;
  align-items: center;
  gap: 30px;
  > .name {
    font-family: Pretendard;
    font-weight: 600;
    font-size: 20px;
    width: 169px;
    color: #121212;
  }
`;

export const EditTournamentReservationInputBox = styled.div`
  display: flex;
  gap: 30px;
  position: relative;
  align-items: flex-start;
  width: max-content;

  > .name {
    font-family: Pretendard;
    font-weight: 600;
    font-size: 20px;
    width: 169px;
    color: #121212;
  }
`;

export const EditTournamentReservationInputContent = styled.div`
  width: 336px;
  height: 450px;
  gap: 0px;
  border-radius: 15px;
  border: 3px dashed #bebebe;
  box-sizing: border-box;
  background: #f0f3f8;
`;
